export function isIEorEdge() {
    return /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
}